import { paraReais } from '../lib/dinheiro.ts';
import { usarSigilo } from '../lib/sigilo.ts';

/**
 * Todo dinheiro que aparece na tela passa por aqui.
 *
 * Um único componente para que ligar o sigilo esconda **tudo** — valor
 * escondido em quatro lugares e visível no quinto é pior que não esconder,
 * porque a pessoa confia que está protegida.
 *
 * Dois motivos diferentes fazem um valor sumir, e o componente trata os dois:
 *
 * | Motivo | O que é | Volta com um clique? |
 * |---|---|---|
 * | o olho do cabeçalho | máscara contra olhar por cima do ombro | sim |
 * | `de === null` | o servidor não mandou: quem olha é colaborador | **não** |
 *
 * O segundo caso não tem como voltar porque o valor **não está na tela** —
 * nem no HTML, nem na resposta da API. Não há o que revelar.
 */
export function Valor({ de, className }: { de: string | number | null; className?: string }) {
  const oculto = usarSigilo();
  const classe = 'dado' + (className ? ` ${className}` : '');

  if (de === null) {
    return (
      <span className={classe} title="Valores são de quem administra o Hub">
        R$ ••••
      </span>
    );
  }

  if (oculto) {
    return (
      <span className={classe} title="Valores ocultos — clique no olho no topo">
        R$ ••••
      </span>
    );
  }
  return <span className={classe}>{paraReais(de)}</span>;
}
